export default "__VITE_ASSET__dcf17e28__"